"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listRefundRequestsQuerySchema = exports.opRefundRequestStatusEnum = exports.approveRefundRequestSchema = exports.rejectRefundRequestSchema = exports.createRefundRequestSchema = void 0;
/**
 * Request contracts for the OP REFUND REQUEST / APPROVAL workflow — desk,
 * 2026-09-12: "submit for main counter... approve or reject".
 *
 * DELIBERATELY SEPARATE from `processRefundRequestSchema`
 * (`financial-refund.request.ts`, frozen Stage 5C.3). That endpoint stays
 * exactly as it is — Pharmacy Returns and Appointment cancellation refunds
 * call it directly today and must keep working unchanged. These schemas
 * front a NEW pair of tables (`OpRefundRequest`) and a NEW pair of
 * endpoints; the money itself still moves through the same frozen
 * `RefundApplicationService.processRefund()` once a request is approved —
 * see that service's own call site in `refund-request.service.ts`.
 */
const zod_1 = require("zod");
exports.createRefundRequestSchema = zod_1.z.object({
    finReceiptId: zod_1.z.string().uuid(),
    /**
     * Which billed line this reverses — see `finInvoiceLineId` on
     * `processRefundRequestSchema` for why this is optional (a whole-receipt
     * reversal legitimately names none).
     */
    finInvoiceLineId: zod_1.z.string().uuid().optional(),
    requestedAmount: zod_1.z.number().int().positive(),
    reason: zod_1.z.string().max(500).optional(),
});
exports.rejectRefundRequestSchema = zod_1.z.object({
    /** Mandatory — desk: "Reject MUST require a mandatory reason." */
    reason: zod_1.z.string().trim().min(1, 'A rejection reason is required').max(500),
    lockVersion: zod_1.z.number().int().positive(),
});
exports.approveRefundRequestSchema = zod_1.z.object({
    lockVersion: zod_1.z.number().int().positive(),
});
exports.opRefundRequestStatusEnum = zod_1.z.enum(['REQUESTED', 'APPROVED', 'REJECTED', 'PROCESSING', 'COMPLETED', 'FAILED']);
exports.listRefundRequestsQuerySchema = zod_1.z.object({
    status: exports.opRefundRequestStatusEnum.optional(),
    limit: zod_1.z.coerce.number().int().positive().max(200).default(50),
});
//# sourceMappingURL=financial-refund-request.request.js.map